module.exports = __webpack_public_path__ + "static/media/dustbin.29e17255.svg";